module.exports = __webpack_public_path__ + "img/19.89260df5.gif";